type CarImageSizes = {
  lg?: string
  md?: string
  original?: string
  sm?: string
}

type CarWithImages = {
  image?: CarImageSizes | null
  images?: Array<{
    id?: number
    image?: CarImageSizes | null
  }> | null
}

export function getCarAvatarUrl(
  car: CarWithImages | null | undefined,
  size: keyof CarImageSizes = 'md'
): string | null {
  if (!car) return null

  const fromImage =
    car.image?.[size] || car.image?.md || car.image?.original || null
  if (fromImage) return fromImage

  const first = car.images?.[0]?.image
  return first?.[size] || first?.md || first?.original || null
}
